import React, { useEffect, useState } from "react";
import { Modal, Radio } from "antd";
import SignagePlayer from "../SignagePlayer";

const PreviewPlaylist = ({ isModalOpen, playlist, closeModal }) => {
  const [orientation, setOrientation] = useState("horizontal");

  const handleOrientationChange = (e) => {
    setOrientation(e.target.value);
  };

  const modalWidth = orientation === "horizontal" ? 450 : 275; // adjust as needed
  const playerHeight = 400;

  return (
    <Modal
      title={`Preview Playlist - ${playlist.title}`}
      open={isModalOpen}
      onCancel={() => {
        closeModal();
      }}
      footer={null}
      maskClosable={false}
    >
      <div className="mb-3">
        <label className="form-label me-3">Orientation</label>
        <Radio.Group
          onChange={handleOrientationChange}
          value={orientation}
          optionType="button"
          buttonStyle="solid"
        >
          <Radio value="horizontal">Horizontal</Radio>
          <Radio value="vertical">Vertical</Radio>
        </Radio.Group>
      </div>
      <div
        className={`preview-media-container ${orientation}`}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: playerHeight,
          overflow: "hidden",
        }}
      >
        <SignagePlayer
          playlist={playlist.media.map((media) => {
            return { media: media, duration: media.duration };
          })}
          classNames={`preview-media ${orientation}`}
        ></SignagePlayer>
      </div>
    </Modal>
  );
};

export default PreviewPlaylist;
